import React from 'react';
import SelectSearch from 'react-select';

class ProductsFilter extends React.Component {
  constructor(props) {
    super(props);

    this.ITEM_TYPE_PRODUCT_GROUP = 'group';
    this.ITEM_TYPE_PRODUCT = 'product';

    this.state = {};

    this.handleProductChange = this.handleProductChange.bind(this);
  }

  componentDidMount() {}

  handleProductChange(product) {
    const type = product.value.split('/')[0];
    const id = product.value.split('/')[1];

    if (this.props.onChange) {
      this.props.onChange(type, id);
    }
  }

  render() {
    let options = [];

    // this.props.appData.cache.kitGroups.forEach((group) => {
    //   options.push({
    //     label: group.name + ' (tutti)',
    //     value: this.ITEM_TYPE_PRODUCT_GROUP + '/' + group.id
    //   });

    //   if (this.props.appData.cache.kitsByGroup[group.id] !== undefined) {
    //     this.props.appData.cache.kitsByGroup[group.id].forEach((product) => {
    //       options.push({
    //         label: ' |___ ' + product.name + ' (A/S ' + product.schoolyear + ')',
    //         value: this.ITEM_TYPE_PRODUCT + '/' + product.id
    //       });
    //     });
    //   }
    // });

    this.props.appData.cache.kitGroups.forEach((group) => {
      // options.push({
      //   label: group.name + ' (tutti)',
      //   value: this.ITEM_TYPE_PRODUCT_GROUP + '/' + group.id
      // });

      if (this.props.appData.cache.kitsByGroup[group.id] !== undefined) {
        this.props.appData.cache.kitsByGroup[group.id].forEach((product) => {
          options.push({
            label: group.name + '/ ' + product.name + ' A.S. ' + product.schoolyear,
            value: this.ITEM_TYPE_PRODUCT + '/' + product.id
          });
        });
      }
    });

    // options.sort((a,b) => {
    //   if (a.label < b.label) return -1;
    //   if (a.label > b.label) return 1;
    //   return 0;
    // });

    let sel = null;
    if (this.props.value) {
      for (let i=0; i<options.length; i++) {
        const optionId = options[i].value.split('/')[1];
        if (optionId == this.props.value) {
          sel = options[i];
        }
      }
    }

    return (
      <div>
        <SelectSearch
          options={options}

          isSearchable={true}
          isClearable={false}

          placeholder="Seleziona prodotto"
          value={sel}

          onChange={this.handleProductChange}
        />
      </div>
    );
  }
}

export default ProductsFilter;


// WEBPACK FOOTER //
// ./src/components/shared/filters/ProductsFilter.js